import { format } from "date-fns"

function DateInput({ value, onChange, label, name, id, required = false }) {
  const handleChange = (e) => {
    if (e.target.value) {
      const date = new Date(e.target.value)
      onChange(date)
    }
  }

  const getInputValue = () => {
    if (!value) return ""
    if (typeof value === "string") {
      return value.split("T")[0]
    }
    return format(new Date(value), "yyyy-MM-dd")
  }

  return (
    <div className="d-flex flex-column field">
      {label && (
        <label className="label-field" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        type="date"
        value={getInputValue()}
        onChange={handleChange}
        className="input-field"
        required={required}
        style={{
          padding: "0.5rem",
          borderRadius: "4px",
          border: "1px solid #ccc",
          fontSize: "1rem",
          width: "100%",
          boxSizing: "border-box",
        }}
      />
    </div>
  )
}

export default DateInput
